import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { 
  Sidebar, 
  SidebarHeading, 
  RecentPostsList, 
  RecentPost, 
  RecentPostTitle, 
  RecentPostDate,
  RecentPostMeta,
  PostCategory,
  HeaderSection
} from './RecentPostsSidebar.styles';

const RecentPostsSidebar = ({ recentPosts, formatDate }) => {
  const { t } = useTranslation();

  return (
    <Sidebar>
      <HeaderSection>
        <SidebarHeading>{t('blogs.recentPosts')}</SidebarHeading>
      </HeaderSection>
      
      <RecentPostsList>
        {recentPosts.slice(0, 4).map((post, index) => (
          <RecentPost key={post._id} $isFirst={index === 0}>
            <Link to={`/blog/${post.slug}`}>
              <RecentPostTitle>
                {post.title}
              </RecentPostTitle>
              
              <RecentPostMeta>
                {post.categories && post.categories.length > 0 && (
                  <PostCategory>
                    {post.categories[0].title}
                  </PostCategory>
                )}
                <RecentPostDate>{formatDate(post.publishedAt)}</RecentPostDate>
              </RecentPostMeta>
            </Link>
          </RecentPost>
        ))}
      </RecentPostsList>
    </Sidebar>
  );
};

export default RecentPostsSidebar;